(ns common.resource.query.agency
  (:require ["@sentry/react" :as Sentry]
            [cljs-bean.core :refer [->clj]]
            [common.queries :refer [invalidate-queries query-client]]
            [common.queries.http :as qhttp]
            [promesa.core :as p]
            [re-frame.core :as rf]))

(defn agency-query [{:keys [agency-id]}]
  #js {:queryKey #js ["agency" agency-id]
       :queryFn (fn [_ctx] (qhttp/get (qhttp/render :api/agency {:agency-id agency-id})))
       :enabled (boolean agency-id)})

(defn transform-agencies [^js data]
  (->> (->clj data)
       (mapv (fn [agency]
               (assoc agency
                      :campaign-count (count (:campaignIds agency))
                      :advertiser-count (count (:advertiserIds agency))
                      :user-count (count (:useraccountIds agency)))))))

(defn superadmin-agencies-query []
  #js {:queryKey #js ["superadmin-agencies"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :superadmin-api/agencies {})))
       :select transform-agencies
       :staleTime (* 60 1000)})

(def ensure-agency-controller
  {:parameters {:path [:agency-id]}
   :start (fn [{path-params :path}]
            (-> (p/let [data (.ensureQueryData query-client (agency-query path-params))
                        agency (->clj data)
                        last-viewed-advertiser-id (some-> (js/localStorage.getItem "last-viewed-advertiser-id") int)]
                  (.setTag ^js Sentry "agency" (:name agency))
                  (when (not-any? #(= % last-viewed-advertiser-id) (:advertiserIds agency))
                    (js/localStorage.removeItem "last-viewed-advertiser-id")))

                (p/catch #(rf/dispatch [:router/update-controller-status
                                        {:failure? true
                                         :failure-props {:code "not_found_error"
                                                         :entity-name "Agency"}}]))))})

(defn all-tenants-query []
  #js {:queryKey #js ["all-tenants"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :superadmin-api/all-tenants {})))
       :staleTime (* 60 1000)})

(defn update-tenant-mutation [agency-id]
  #js {:mutationKey #js ["update-tenant-mutation" agency-id]
       :mutationFn (fn [tenant-id]
                     (qhttp/patch (qhttp/render :superadmin-api/update-agency-tenant {:agency-id agency-id})
                                  {:body {:tenant-id tenant-id}}))
       :onMutate (fn [] (rf/dispatch [:loader/open]))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onError (fn [response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Agency"
                                 :type :error
                                 :message "Failed to set tenant mapping. It is already mapped to other Agency."
                                 :response response}]))
       :onSuccess (fn [_response]
                    (rf/dispatch [:ocp/close])
                    (invalidate-queries {:queryKey ["superadmin-agencies"]}))})

(defn refresh-all-tenants-mutation []
  #js {:mutationKey #js ["refresh-all-tenants"]
       :mutationFn (fn [_ctx]
                     (qhttp/post (qhttp/render :superadmin-api/all-tenants {})))})
